module.exports = __webpack_public_path__ + "static/mugshot-97c3d767a4a9bbd652ddc7d8c4f33b5d.mp4";